<template>
  <div>
    <h2>
      <v-icon color="accent">{{icono}}</v-icon>
      {{titulo}}
    </h2>
    <br>
    <v-form v-model="valid" ref="form">
    <v-layout row wrap>
      <v-flex xs12 sm10 md10 lg10 class="pr-2">
        <v-layout row wrap>
          <v-flex xs2 sm2 md2 lg2>
            <strong class="mr-1">ID</strong>
          </v-flex>
          <v-flex xs6 sm6 md6 lg6>
            <strong>{{ registro.id}}</strong>
          </v-flex>
        </v-layout>

        <ClienteAutocomplete v-if="accion==1 || selectedCliente" required v-model="selectedCliente"></ClienteAutocomplete>

        <v-text-field
          label="Nombre"
          v-model="registro.nombre"
          :rules="nameRules"
          :counter="20"
          required
        ></v-text-field>
        <v-text-field
          label="Marca"
          v-model="registro.marca"
          :rules="nameRules"
          :counter="20"
          required
        ></v-text-field>
        <v-text-field
          label="Vehiculo"
          v-model="registro.vehiculo"
          :rules="nameRules"
          :counter="20"
          required
        ></v-text-field>
        <v-text-field
          label="Modelo"
          v-model="registro.modelo"
          type="number" step="1"
        ></v-text-field>
        <v-text-field
          label="Matrícula"
          v-model="registro.matricula"
          :rules="nameRules"
          :counter="8"
        ></v-text-field>
        <v-text-field
          label="Color"
          v-model="registro.color"
          :rules="nameRules"
          :counter="12"
        ></v-text-field>
        <v-checkbox
          label="Activo"
          v-model="registro.activo"
        ></v-checkbox>

        <v-expansion-panel popout>
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon small>fas fa-globe</v-icon>
              GPS
            </div>
            <v-card>
              <v-card-text>

                <v-checkbox
                  label="Inicializado"
                  v-model="registro.gpsInicializado"
                ></v-checkbox>

                <v-select
                  :items="carriers"
                  :item-text="'nombre'" :item-value="'id'"
                  v-model="selectedCarrier"
                  label="Carrier" required
                ></v-select>
                <v-select
                  :items="servidores"
                  :item-text="'descripcion'" :item-value="'id'"
                  v-model="selectedServidor"
                  label="Servidor" required
                ></v-select>

                <v-text-field
                  label="Límite de velocidad"
                  v-model="registro.velocidadLimite"
                  type="number"
                ></v-text-field>
                <v-text-field
                  label="IMEI"
                  v-model="registro.gpsIMEI"
                  type="number"
                ></v-text-field>
                <v-text-field
                  label="Pin inmovilizador"
                  v-model="registro.gpsPinInmovilizador"
                  type="number"
                ></v-text-field>
                <v-text-field
                  label="Teléfono"
                  v-model="registro.gpsTelefono"
                  type="string"
                ></v-text-field>
                <v-text-field
                  label="GPS Modelo"
                  v-model="registro.gpsModelo"
                  type="string"
                ></v-text-field>
                <v-text-field
                  label="GPS Password"
                  v-model="registro.gpsPassword"
                  type="string"
                ></v-text-field>
                <v-checkbox
                  label="TCP"
                  v-model="registro.gpsTCP"
                ></v-checkbox>
                <v-checkbox
                  label="Inmovilizado"
                  v-model="registro.gpsInmovilizado"
                ></v-checkbox>
                <v-menu
                  ref="menu"
                  lazy
                  :close-on-content-click="false"
                  v-model="menu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Fecha de Instalación"
                    v-model="registro.gpsFechaInstalacion"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="registro.gpsFechaInstalacion"
                    @change="save"
                    min="2015-01-01"
                    :max="new Date().toISOString().substr(0, 10)"
                  ></v-date-picker>
                </v-menu>

              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div slot="header"><v-icon small>fas fa-thumbtack</v-icon>
              Autotrack</div>
            <v-card>
              <v-card-text>
                <v-switch
                  label="Autotrack Activo"
                  v-model="registro.gpsAutotrack.activo"
                ></v-switch>
                <v-text-field
                  label="Intervalo"
                  v-model="registro.gpsAutotrack.intervalo"
                  type="number" :disabled="!registro.gpsAutotrack.activo"
                ></v-text-field>
                <v-radio-group v-model="registro.gpsAutotrack.tiempo">
                  <v-radio
                    v-for="n in ['SEGUNDOS','MINUTOS','HORAS']"
                    :key="n" :disabled="!registro.gpsAutotrack.activo"
                    :label="`${n}`"
                    :value="n"
                  ></v-radio>
                </v-radio-group>
                <v-text-field
                  label="Cantidad" :disabled="!registro.gpsAutotrack.activo"
                  v-model="registro.gpsAutotrack.cantidad"
                  type="string"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content>
            <div slot="header"><v-icon small>fas fa-images</v-icon>
              Imágenes
            </div>
            <v-card>
              <v-card-text>
                <v-layout row spacer align-center>
                <v-flex xs5 sm3 md2>
                  <v-avatar class="ml-4"
                    size="40px"
                    slot="activator">
                    <img class="mx-3"
                      :src="iconoPath"
                      alt="">
                    Marcador
                  </v-avatar>
                  </v-flex>
                  <v-flex xs5 sm3 md2>
                    <SvgComponent :vehiculoId="registro.id" v-on:update-icon="updateIcon()"></SvgComponent>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

        </v-expansion-panel>
        <v-layout row wrap class="mt-3">
          <v-flex xs6 sm4>
            <span class="mr-3">Fecha de Creación</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span class="info--text">{{ registro.fechaCreacion | date}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Fecha de Actualización</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span class="info--text">{{ registro.fechaActualizacion | date}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Usuario Creación</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.usuarioCreacion" class="info--text">{{ registro.usuarioCreacion.username}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Grupo</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.group" class="info--text">{{ registro.group.name}}</span>
          </v-flex>
          <v-flex xs6 sm4>
            <span class="mr-3">Propietario</span>
          </v-flex>
          <v-flex xs6 sm5>
            <span v-if="registro.propietario" class="info--text">{{ registro.propietario.username}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm2 md2 lg2>
        <v-btn
          block
          @click="submit"
          :disabled="!valid"
          color="success"
        >
          <v-icon v-show="accion == 1" small left>fas fa-plus</v-icon>
          <v-icon v-show="accion == 2" small left>fas fa-edit</v-icon>
          <span v-show="accion == 1">Agregar</span>
          <span v-show="accion == 2">Actualizar</span>
        </v-btn>
        <v-btn @click="dialogoEliminar" block color="error" v-show="accion == 2">
          <v-icon left small>fas fa-trash-alt</v-icon>
          Eliminar
        </v-btn>
        <v-btn @click="cancelar" block >
          <v-icon left small>fas fa-chevron-left</v-icon>
          cancelar
        </v-btn>
        <Ownership v-if="accion == 2" :objeto="registro"></Ownership>
      </v-flex>
    </v-layout>
    </v-form>

    <v-dialog v-model="dialog3" max-width="400px">
      <v-card>
        <v-card-title>
          <span>Confirme que desea eliminar el registro</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="error" @click.stop="eliminar()">
            <v-icon left small>fas fa-trash-alt</v-icon>
            Aceptar
          </v-btn>
          <v-btn flat @click.stop="dialog3=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <br>
    <v-divider></v-divider>
    <br>
    <v-tabs
      v-model="tabActivo"
      color="cyan"
      dark
      slider-color="yellow"
      v-if="accion == 2 && registro.id"
    >
      <v-tab v-for="t in tabs" :key="t.id" ripple>
        {{ t.titulo }}
      </v-tab>
      <v-tab-item :key="1">
        <VehiculoHistorial :vehiculo="registro.id"></VehiculoHistorial>
      </v-tab-item>
      <v-tab-item :key="2">
        Relación 2
      </v-tab-item>
    </v-tabs>

  </div>
</template>

<script>
import Vehiculos from '../../services/vehiculos'
import Ownership from '../shared/OwnershipComponent'
import ClienteAutocomplete from '../shared/ClienteAutocompleteComponent'
import VehiculoHistorial from './VehiculoHistorialLista'
import Carriers from '../../services/carriers'
import Servidores from '../../services/servidores'
import SvgComponent from '../shared/SvgComponent'

export default {
  name: 'VehiculoDetalle',
  data () {
    return {
      titulo: 'Vehiculo Detalle',
      icono: 'fas fa-car',
      accion: null,
      e1: true,
      dialog3: false,
      iconoPath:'',
      menu: false,
      registro: { name: '', activo: true, gpsAutotrack: {activo: false}},
      valid: true,
      selectedCarrier: null,
      selectedServidor: null,
      servidores: [],
      carriers: [],
      tabActivo: null,
      selectedCliente: null,
      nameRules: [
        v => !!v || 'Ingrese un nombre de Vehiculo válido',
        v => (v && v.length <= 45) || 'El nombre debe ser menor a 45 caracteres'
      ],
      mensaje: false,
      tabs: [
        {id: 1, titulo: 'Historial'}
      ],
      filtroVehiculos: null
    }
  },
  components: {
    Ownership,
    ClienteAutocomplete,
    VehiculoHistorial,
    SvgComponent
  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  provide: function () {
    return {
      servicio: Vehiculos
    }
  },
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        this.registro.cliente = this.selectedCliente
        this.registro.carrier = this.selectedCarrier
        this.registro.servidor = this.selectedServidor
        if (this.accion === 1) {
          this.registro = await Vehiculos.save(this.registro)
          this.accion = 2
          this.$emit('show-message', {msg: 'Registro Guardado', tipo: 'success'})
        } else {
          this.registro = await Vehiculos.update(this.registro)
          this.$emit('show-message', {msg: 'Registro Actualizado', tipo: 'success'})
          this.mensaje = true
        }
      }
    },
    save(date) {
      this.$refs.menu.save(date)
    },
    updateIcon() {
      this.iconoPath = process.env.VUE_APP_API_URL + '/images/loading.svg'
      setTimeout(() => {
        this.iconoPath = process.env.VUE_APP_API_URL + '/images/vehiculos/' + this.registro.id + '/icono.svg?' + this.makeid()
      },2000)
    },
    makeid() {
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
    async eliminar() {
      await Vehiculos.delete(this.registro.id)
      this.dialog3 = false
      this.$emit('show-message', 'Registro Eliminado')
      setTimeout(this.cancelar, 800)
    },
    cancelar () {
      this.$router.push('/vehiculos')
    },
    dialogoEliminar() {
      this.dialog3 = true
    }
  },
  beforeMount: async function() {
    if (this.$route.params.id === '0') {
      this.accion = 1 //Agregar
    } else {
      this.accion = 2 //Actualizar
      this.registro = await Vehiculos.get(this.$route.params.id, { populate: 'usuarioCreacion,propietario,cliente,icono,vehiculo'})
      if (!this.registro) {
        this.cancelar()
      } else {
        this.selectedCliente = this.registro.cliente
        this.selectedCarrier = this.registro.carrier
        this.selectedServidor = this.registro.servidor
      }
      this.filtroVehiculos = { registro: this.registro.id }
    }
    this.carriers = await Carriers.list({ populate: 'usuarioCreacion', select: 'nombre'})
    this.servidores = await Servidores.list({ populate: 'usuarioCreacion', select: 'descripcion,direccionIP', activo:true})
    this.iconoPath = process.env.VUE_APP_API_URL + '/images/vehiculos/' + this.registro.id + '/icono.svg?' + this.makeid()
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/vehiculos/VehiculoDetalle.vue